import { Box, Breadcrumbs, Typography, Link as MuiLink, Grid2 } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useAuth } from "../../AuthContext";

const frontNine = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9
];

const backNine = [
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18
];

export default function RoundDetail() {
  const params = useParams();
  const auth = useAuth();
  const [isPending, setIsPending] = useState(true);
  const [roundData, setRoundData] = useState();
  
  const scoreCard = useMemo(() => {
    if (!roundData?.scores) {
      return {};
    }
    const players = {};

    roundData.scores
    .sort((a, b) => a.hole < b.hole ? -1 : 1)
    .forEach(score => {
      if (!players[score.player]) {
        players[score.player] = {
          front: [...frontNine.map(hole => ({ hole, score: -1 }))],
          frontTotal: 0,
          back: [...backNine.map(hole => ({ hole, score: -1 }))],
          backTotal: 0,
          total: 0
        };
      }
      if (score.hole < 10) {
        players[score.player].front[score.hole - 1] = score;
        players[score.player].frontTotal += score.score;
      } else {
        players[score.player].back[score.hole - 10] = score;
        console.log(players[score.player].back);
        players[score.player].backTotal += score.score;
      }
      players[score.player].total += score.score;
    });
    console.log('players', players);
    return players;
  }, [roundData]);

  const fetchRound = useCallback(async () => {
    if (params.roundId) {
      const res = await auth.request(`/api/stats/round/${params.roundId}`);
      console.log(res);
      if (res.data) {
        setRoundData(res.data);
      }
      setIsPending(false);
    }
  }, [params.roundId]);
  
  useEffect(() => {
    fetchRound();
  }, []);

  if (isPending) {
    return null;
  }
  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      <Breadcrumbs>
        {/* <MuiLink
          underline="hover"
          color="inherit"
          component={Link}
          to="/account"
        >
          Account
        </MuiLink> */}
        <MuiLink
          underline="hover"
          color="inherit"
          component={Link}
          to="/account/rounds"
        >
          Rounds
        </MuiLink>
        <Typography sx={{ color: 'text.primary' }}>{roundData.course}</Typography>
      </Breadcrumbs>
      
      <Box sx={{ py: 3, width: '100%', overflow: 'auto' }}>
        <Box sx={{ minWidth: 1100, fontSize: 11 }}>
          <Grid2 container spacing={3} sx={{ mb: 2, pb: 2, borderBottom: '1px solid #eee' }}>
            <Grid2 sx={{ width: 90 }}>
              Hole
            </Grid2>
            {frontNine.map((hole, index) => (
              <Grid2 sx={{ width: 15 }} key={hole}>{hole}</Grid2>
            ))}
            <Grid2 sx={{ width: 40 }}>OUT</Grid2>
            {backNine.map((hole, index) => (
              <Grid2 sx={{ width: 15 }} key={hole}>{hole}</Grid2>
            ))}
            <Grid2 sx={{ width: 40 }}>IN</Grid2>
          </Grid2>
          {Object.entries(scoreCard).map(([player, scores]) => (
            <Grid2 container key={player} spacing={3} sx={{ mb: 3 }}>
              <Grid2 sx={{ width: 90 }}>
                {player}
              </Grid2>
              {scores.front.map(score => (
                <Grid2 sx={{ width: 15 }} key={`${score.hole}${score.score}`}>
                  {score.score >= 0 ? score.score : ' '}
                </Grid2>
              ))}
              <Grid2 sx={{ width: 40 }}>{scores.frontTotal}</Grid2>

              {scores.back.map(score => (
                <Grid2 sx={{ width: 15 }} key={`${score.hole}${score.score}`}>
                  {score.score >= 0 ? score.score : ' '}
                </Grid2>
              ))}
              <Grid2 sx={{ width: 40 }}>{scores.backTotal}</Grid2>
              <Grid2 sx={{ width: 40 }}>{scores.total}</Grid2>
            </Grid2>
          ))}
        </Box>
      </Box>
    </Box>
  )
}